import * as yup from "yup";

import { useEffect } from "react";
import { IoPlayOutline, IoReload } from "react-icons/io5";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import ReactSelect from "./../../../components/common/ReactSelect";

import journalService from "../../../services/journalService";

const schema = yup.object();

const UnpostedEntriesFilter = ({ options, onFilter }) => {
  const references = journalService.getJournalReferences();

  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = (info) => {
    const reference =
      info.reference && info.reference !== undefined
        ? info.reference.value
        : "";

    onFilter(reference);
  };

  const handleReset = () => {
    const reference = "";
    onFilter(reference);
  };

  useEffect(() => {
    if (options) {
      const { reference } = options;
      const references = journalService.getJournalReferences();
      const selected = references.filter((i) => i.value === reference);

      setValue("reference", selected);
    }
  }, [options, setValue]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8 space-y-6">
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <ReactSelect
            id="reference-dropdown"
            name="reference"
            title="Reference"
            options={references}
            control={control}
            register={register("reference")}
            errors={errors}
            isClearable
          />
        </div>
      </div>
      <div className="grid grid-cols-5 gap-2 pt-5">
        <div className="col-span-2">
          <button
            type="button"
            onClick={handleReset}
            className="button bg-gray-200 text-gray-500"
          >
            Reset <IoReload className="ml-2" />
          </button>
        </div>
        <div className="col-span-3">
          <button type="submit" className="button button-primary">
            Apply Filter <IoPlayOutline className="ml-2" />
          </button>
        </div>
      </div>
    </form>
  );
};

export default UnpostedEntriesFilter;
